<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        center
        class="detail-dialog-container"
        width="960px">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">单位会员</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-wrap">
                <div class="team flex flex-direction align-center justify-center"
                     v-for="(item,index) in teams" :key="index">
                    <el-image class="image" :src="item.headImg"></el-image>
                    <div class="company">{{item.company}}</div>
                </div>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                class="self-end"
                layout="prev, pager, next, jumper"
                @current-change="init">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>

import {getMemberList} from "../../api/data";

export default {
    name: "MoreTeamDialog",
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        },
        oid: { //详情ID
            type: Number,
        }
    },
    data() {
        return {
            teams:[],
            page: 1,
            limit:9,
            total:0
        }
    },
    created() {
        if (this.oid)this.init()
    },
    methods: {
        async init() {
            let _data = await getMemberList(this.oid,1,this.page,this.limit)
            this.teams = _data.data
            this.total = _data.total_number
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    watch: {
        id() {
            if (this.oid)this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            height: 420px;
            padding: 0 20px;
            align-content: flex-start;
            .team {
                width: 272px;
                height: 111px;
                background-color: #f1f4f5;
                border-radius: 6px;
                margin-top: 15px;

                &:not(:nth-child(3n+1)) {
                    margin-left: 19px;
                }

                .image {
                    width: 51px;
                    height: 51px;
                    border-radius: 51px;
                }

                .company {
                    font-size: 16px;
                    color: #333333;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
